import { ChevronRight } from 'lucide-react';
import type { DetailsHTMLAttributes, ReactNode } from 'react';

/**
 * Shared disclosure. Every expandable section uses the same right-pointing
 * chevron, rotated down when open, in place of the browser's default triangle
 * marker. The marker is inline so block summaries keep floated or badged
 * content, and flex summaries keep their own alignment.
 */
export function Disclosure({
  summary,
  summaryClassName,
  className,
  children,
  ...props
}: Omit<DetailsHTMLAttributes<HTMLDetailsElement>, 'title'> & {
  summary: ReactNode;
  summaryClassName?: string;
  children: ReactNode;
}) {
  return (
    <details {...props} className={['ui-disclosure', className].filter(Boolean).join(' ')}>
      <summary className={summaryClassName}>
        <ChevronRight className="ui-disclosure-marker" aria-hidden="true" />
        {summary}
      </summary>
      {children}
    </details>
  );
}
